import '@Libs/navigator.sendbeacon.min';
import './backward-compatibility/global';

import { boot } from './main';

boot();